import {toast} from "react-toastify";
import i18next from '../app/i18n'

/**
 * @param p  Promesse à remplir
 * @constructor
 */
const loadSpinner = (p) => {

    toast.dismiss();
    toast.promise(p, {
        pending: i18next.t("toast.enCours"),
        success: i18next.t("toast.succes"),
        error: i18next.t("toast.erreur"),
    }, {autoClose: 1500});
}

export {
    loadSpinner
};
